module.exports = __webpack_public_path__ + "static/media/pepblast-campaign-manager.9a0f0b06.png";